import React, { useEffect } from 'react';
import { usePilotContext } from '../../../../contexts/pilot.context';
import { actionTypes } from '../../../../ducks/pilot.duck';
import { getPilotStatus } from '../../../../selectors/pilot.selector';
import PilotsView from './pilots-list.view';

const Pilots: React.FC = () => {
  const { state, actions } = usePilotContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <PilotsView
      loading={getPilotStatus(state, actionTypes.PILOT_FETCH).fetching}
      data={state.list}
    />
  );
};

export default Pilots;
